import { oneOfOptionsPaths, requiredPaths } from '../constants/schema';

export const getDepth = (path?: string): number => {
  return path?.split('.').length ?? 1;
};

export const isTopLevel = (depth: number): boolean => {
  return depth === 1;
};

export const isRequired = (isTopLevel: boolean, path: string): boolean => {
  const isOneOfOption = oneOfOptionsPaths.includes(path);
  if (isOneOfOption) {
    return true;
  }

  const fileExportPathRegex = /^export\.\d+\.format$/;
  return !isTopLevel && (requiredPaths.includes(path ?? '') || fileExportPathRegex.test(path ?? ''));
};

export const getParentPath = (path: string): string => path.split('.').slice(0, -1).join('.');
